module.exports = __webpack_public_path__ + "img/chuvoso.50caa25a.png";